import api from '@/services/api.service';

import { required, minLength, sameAs } from "vuelidate/lib/validators";
export default {
  name: 'reset-password',
  components: {},
  props: [],
  data () {
    return {
      log: { password: '', confirmPassword: '' },
      errors: '',
      msg: '',
      submitStatus: null,
      loader: false
  };
  },
  computed: {

  },
  validations: {
    log: {
      password: { required, minLength: minLength(6) },
      confirmPassword: { required, sameAsPassword: sameAs('password') }
    }
  },
  mounted () {

  },
  methods: {
    makeToast(message = '', title = 'Alert', variant = 'warning') {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
          title: title,
          variant: variant,
          autoHideDelay: 3000
      });
    },
    async save() {
      this.$v.$touch();
        if (this.$v.$invalid) {
            this.submitStatus = 'ERROR';
        } else{ this.log.token = this.$route.params.token;
         this.log.email = this.$route.params.email;
         let response = await api.post('/resetPassword', this.log);
          
            if (!response) this.makeToast('Something went to wrong please try again', 'Alert', 'danger', 6000);
            if (response.status == 'success') {
              this.makeToast('Password reset successfully', 'Success', 'success', 6000);
              this.$router.push({ name: 'Login' });
            }else{
              for(var error in response.errors){
                this.makeToast(response.errors[error],'Alert','danger');
              }
            }
        }
    }

  }
}


